import { Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import { EditButton, GreenText, LabelField } from 'components'
import { getBuyerExporterCompanies, saveDestination } from 'controllers/outboundTrips/index'
import { BuyerExporterCompanyDto, OutboundTripDetailDto } from 'dtos/outboundTrips'
import { OutboundTripDetailDestinationDto } from 'dtos/outboundTrips/OutboundTripDetailDestinationDto'
import { enqueueSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { formatAddress } from 'utils'
import DestinationDialog from './DestinationDialog'

interface DestinationCardProps {
  destination?: OutboundTripDetailDestinationDto
  outboundTripGuid?: string
  setState: (values: OutboundTripDetailDto) => void
}

export default function DestinationCard({ destination, outboundTripGuid, setState }: DestinationCardProps) {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)
  const [isSaving, setIsSaving] = useState<boolean>(false)
  const [buyerExporterCompanies, setBuyerExporterCompanies] = useState<BuyerExporterCompanyDto[]>([])

  useEffect(() => {
    getBuyerExporterCompanies().then(res => setBuyerExporterCompanies(res.value))
  }, [])

  return (
    <>
      <DestinationDialog
        buyerExporterCompanies={buyerExporterCompanies}
        initialValues={destination ?? { destinationCompany: undefined, destinationAddress: undefined }}
        isLoading={isSaving}
        onClose={() => setDialogOpen(false)}
        onSave={values => {
          setIsSaving(true)
          saveDestination(outboundTripGuid!, values)
            .then(res => {
              enqueueSnackbar('Outbound Trip Destination Saved Successfully!', { variant: 'success' })
              setState({ destination: res.value })
              setDialogOpen(false)
            })
            .finally(() => setIsSaving(false))
        }}
        open={dialogOpen}
      />

      <Card>
        <CardContent>
          <Grid container spacing={2} alignItems='flex-start'>
            <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
              <Grid item xs={12} sm='auto'>
                <Typography fontWeight='bold' variant='h6'>
                  Outbound Trip Destination
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto'>
                <EditButton onEdit={() => setDialogOpen(true)} />
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid item xs={12}>
              <LabelField label='Outbound Trip Destination' value={destination?.destinationCompany?.name} />
            </Grid>

            <Grid item xs={12}>
              <LabelField
                label='Outbound Trip Destination Address'
                value={destination?.destinationAddress ? formatAddress(destination.destinationAddress) : undefined}
              />
            </Grid>

            <Grid item xs={12}></Grid>

            <Grid item xs={12}>
              <GreenText variant='outlined'>
                {`**EDIT Button:**

Clicking the EDIT button opens the Edit Outbound Trip Destination Dialog.

**Outbound Trip Destination Label:**

Displays the name of the Buyer or Exporter Company associated with the trip.

If no value has been entered for the Outbound Trip Destination, a “-” will be displayed.

**Outbound Trip Destination Address Label:**

This is a manually entered address.

Users may select from any of the Vehicle Destination Addresses associated with the selected Buyer or Exporter Company.

**Address Fields:**

The destination address includes:
   - Address 1
   - Address 2
   - City
   - State / Province
   - ZIP / Postal Code`}
              </GreenText>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
